import { Component, Input, OnInit } from '@angular/core';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';
import { BusinessPropertiesObject } from 'src/app/models/tasks/tasks-properties/business-properties/business-properties-object.model';
import { TaskPropertiesObject } from 'src/app/models/tasks/tasks-properties/task-properties/task-properties-object.model';
@Component({
  selector: 'app-business-properties',
  templateUrl: './business-properties.component.html',
  styleUrls: ['./business-properties.component.css']
})
export class BusinessPropertiesComponent implements OnInit {

  businessProperties: BusinessPropertiesObject;
  taskProperties: TaskPropertiesObject;
  @Input() taskDetails: TaskDetailsObject;

  constructor() {
  }

  ngOnInit() {
    this.businessProperties = this.taskDetails.getProperties().getBusinessProperties();
    this.taskProperties = this.taskDetails.getProperties().getTaskProperties();
  }
}
